export const CONTENT_EXCEPTIONS = [
  'AnnotationImageCard',
  'TopPosts',
  'TopLikedPosts',
  'NewPosts',
  'TopPostsByFollowers',
  'TopPostsByInteractions',
  'PropTopCommentsPosts',
  'TimelineProprietaryPosts',
  'PropTopPosts',
];

export const CHART_EXCEPTIONS = [
  'ChannelPieChart',
  'DevicePieChart',
  'GenderPieChart',
  'PropChannelPieChart',
  'PropSentimentPie',
  'BlipEventTrackPieChart',
  'BaseTimeSeries',
  'SacOperatorsTimeSeries',
  'FanBaseEvolutionCompetitiveChart',
  'FanBaseEvolutionChart',
  'BaseBlipLineChart',
  'BlipEventTrackInTime',
];
